import React, { useEffect, useMemo, useState } from 'react';
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
} from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';

const ResponsivePolicyTable = ({
  columns,
  data,
  keyField,
  rowEvents,
  defaultSorted,
  pageSize = 10,
}) => {
  const [page, setPage] = useState(1);

  const sortedData = useMemo(() => {
    const rows = Array.isArray(data) ? data : [];

    if (!defaultSorted || !defaultSorted.length) {
      return rows;
    }

    const sort = defaultSorted[0];
    return [...rows].sort((a, b) => {
      const left = a[sort.dataField];
      const right = b[sort.dataField];

      if (left === right) {
        return 0;
      }

      if (sort.order === 'DESC') {
        return left < right ? 1 : -1;
      }

      return left > right ? 1 : -1;
    });
  }, [data, defaultSorted]);

  const totalPages = Math.max(1, Math.ceil(sortedData.length / pageSize));
  const visibleRows = sortedData.slice((page - 1) * pageSize, page * pageSize);

  useEffect(() => {
    setPage(1);
  }, [data]);

  useEffect(() => {
    if (page > totalPages) {
      setPage(totalPages);
    }
  }, [page, totalPages]);

  const handleRowClick = (event, row) => {
    if (rowEvents && rowEvents.onClick) {
      rowEvents.onClick(event, row);
    }
  };

  return (
    <div className="policy-responsive-table">
      <Table className="policy-responsive-table__table">
        <Thead>
          <Tr>
            {columns.map((column) => (
              <Th key={column.dataField}>{column.text}</Th>
            ))}
          </Tr>
        </Thead>
        <Tbody>
          {visibleRows.length ? (
            visibleRows.map((row, rowIndex) => (
              <Tr
                key={row[keyField] || rowIndex}
                onClick={(event) => handleRowClick(event, row)}
                className={rowEvents && rowEvents.onClick ? 'policy-responsive-table__row--clickable' : ''}
              >
                {columns.map((column, columnIndex) => (
                  <Td key={column.dataField} columnKey={columnIndex}>
                    {row[column.dataField] === undefined || row[column.dataField] === null
                      ? 'N/D'
                      : row[column.dataField]}
                  </Td>
                ))}
              </Tr>
            ))
          ) : (
            <Tr>
              <td colSpan={columns.length} className="policy-responsive-table__empty">
                No hay datos disponibles
              </td>
            </Tr>
          )}
        </Tbody>
      </Table>

      {totalPages > 1 && (
        <div className="policy-responsive-table__pagination">
          <button
            type="button"
            onClick={() => setPage(page - 1)}
            disabled={page === 1}
          >
            Anterior
          </button>
          <span>
            {page} de {totalPages}
          </span>
          <button
            type="button"
            onClick={() => setPage(page + 1)}
            disabled={page === totalPages}
          >
            Siguiente
          </button>
        </div>
      )}
    </div>
  );
};

export default ResponsivePolicyTable;
